'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function hasComplex(props) {
  // reflect types in the documentation if changed
  var quicks = ['string', 'number', 'undefined', 'boolean', 'symbol'];

  return !!Object.keys(props).filter(function (key) {
    return Object.prototype.hasOwnProperty.call(props, key);
  }).map(function (key) {
    return props[key];
  }).find(function (prop) {
    return !quicks.find(function (quickTypeName) {
      return (typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === quickTypeName;
    });
  });
}

exports.default = hasComplex;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-through/lib/hasComplex.js
// module id = 242
// module chunks = 0